// const BASE_URL = "https://edluminaadmin.wizzgeeks.com/api/";
// const BASE_URL = "http://localhost:7201";

// const SOCKET_URL = "wss://edluminaadmin.wizzgeeks.com/api//ws";
// const SOCKET_URL = "ws://localhost:7201/ws";

const BASE_URL = process.env.REACT_APP_API_URL;
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const GET_COURSES_URL = `${BASE_URL}/api/admin/course/get/all`;
export const GET_ALL_BOARDS_URL = `${BASE_URL}/api/admin/board/get/all`;
export const GET_ALL_CLASS_NAMES_URL = `${BASE_URL}/api/admin/class-name/get/all`;
export const GET_ALL_BOARDS_URL_INSTITUTION = `${BASE_URL}/api/institution/board/get/all`;
export const GET_ALL_CLASS_NAMES_URL_INSTITUTION = `${BASE_URL}/api/institution/class-name/get/all`;
export const GET_ALL_BOARDS_URL_TEACHER = `${BASE_URL}/api/teacher/board/get/all`;
export const GET_ALL_CLASS_NAMES_URL_TEACHER = `${BASE_URL}/api/teacher/class-name/get/all`;
export const ADD_COURSE_URL = `${BASE_URL}/api/admin/course/create`;
export const UPDATE_COURSE_URL = `${BASE_URL}/api/admin/course/update`;
export const DELETE_COURSE_URL = `${BASE_URL}/api/admin/course/delete`;
export const GET_COURSE_BY_ID_URL = `${BASE_URL}/api/admin/course/get`;
export const GET_PAGES_FOR_COURSE_URL = `${BASE_URL}/api/admin/course-page-content/get/all`;
export const GET_PAGE_FOR_COURSE_URL = `${BASE_URL}/api/admin/course-page-content/get`;
export const UPDATE_PAGE_FOR_COURSE_URL = `${BASE_URL}/api/admin/course-page-content/update`;
export const CREATE_PAGE_FOR_COURSE_URL = `${BASE_URL}/api/admin/course-page-content/create`;
export const DELETE_PAGE_FOR_COURSE_URL = `${BASE_URL}/api/admin/course-page-content/delete`;
export const UPDATE_SEQUENCE_FOR_COURSE_URL = `${BASE_URL}/api/admin/course-page-content/update/sequence`;
export const DELETE_PAGE_FOR_SUBTOPIC_URL = `${BASE_URL}/api/admin/subtopic-page-content/delete`;
export const GET_ALL_SUBJECTS_URL = `${BASE_URL}/api/admin/subject/get/all`;
export const ADD_SUBJECT_URL = `${BASE_URL}/api/admin/subject/create`;
export const UPDATE_SUBJECT_URL = `${BASE_URL}/api/admin/subject/update`;
export const DELETE_SUBJECT_URL = `${BASE_URL}/api/admin/subject/delete`;
export const GET_SUBJECT_BY_ID_URL = `${BASE_URL}/api/admin/subject/get`;
export const GET_PAGES_FOR_SUBJECT_URL = `${BASE_URL}/api/admin/subject-page-content/get/all`;
export const GET_PAGE_FOR_SUBJECT_URL = `${BASE_URL}/api/admin/subject-page-content/get`;
export const UPDATE_PAGE_FOR_SUBJECT_URL = `${BASE_URL}/api/admin/subject-page-content/update`;
export const CREATE_PAGE_FOR_SUBJECT_URL = `${BASE_URL}/api/admin/subject-page-content/create`;
export const DELETE_PAGE_FOR_SUBJECT_URL = `${BASE_URL}/api/admin/subject-page-content/delete`;
export const UPDATE_SEQUENCE_FOR_SUBJECT_URL = `${BASE_URL}/api/admin/subject-page-content/update/sequence`;

export const GET_ALL_TOPICS_URL = `${BASE_URL}/api/admin/topic/get/all`;
export const ADD_TOPIC_URL = `${BASE_URL}/api/admin/topic/create`;
export const UPDATE_TOPIC_URL = `${BASE_URL}/api/admin/topic/update`;
export const DELETE_TOPIC_URL = `${BASE_URL}/api/admin/topic/delete`;
export const GET_TOPIC_BY_ID_URL = `${BASE_URL}/api/admin/topic/get`;
export const GET_PAGES_FOR_TOPIC_URL = `${BASE_URL}/api/admin/topic-page-content/get/all`;
export const GET_PAGE_FOR_TOPIC_URL = `${BASE_URL}/api/admin/topic-page-content/get`;
export const UPDATE_PAGE_FOR_TOPIC_URL = `${BASE_URL}/api/admin/topic-page-content/update`;
export const CREATE_PAGE_FOR_TOPIC_URL = `${BASE_URL}/api/admin/topic-page-content/create`;
export const DELETE_PAGE_FOR_TOPIC_URL = `${BASE_URL}/api/admin/topic-page-content/delete`;
export const UPDATE_SEQUENCE_FOR_TOPIC_URL = `${BASE_URL}/api/admin/topic-page-content/update/sequence`;

export const GET_ALL_SUBTOPICS_URL = `${BASE_URL}/api/admin/subtopic/get/all`;
export const ADD_SUBTOPIC_URL = `${BASE_URL}/api/admin/subtopic/create`;
export const UPDATE_SUBTOPIC_URL = `${BASE_URL}/api/admin/subtopic/update`;
export const DELETE_SUBTOPIC_URL = `${BASE_URL}/api/admin/subtopic/delete`;
export const GET_SUBTOPIC_BY_ID_URL = `${BASE_URL}/api/admin/subtopic/get`;
export const GET_PAGES_FOR_SUBTOPIC_URL = `${BASE_URL}/api/admin/subtopic-page-content/get/all`;
export const GET_PAGE_FOR_SUBTOPIC_URL = `${BASE_URL}/api/admin/subtopic-page-content/get`;
export const UPDATE_PAGE_FOR_SUBTOPIC_URL = `${BASE_URL}/api/admin/subtopic-page-content/update`;
export const CREATE_PAGE_FOR_SUBTOPIC_URL = `${BASE_URL}/api/admin/subtopic-page-content/create`;
export const UPDATE_SEQUENCE_FOR_SUBTOPIC_URL = `${BASE_URL}/api/admin/subtopic-page-content/update/sequence`;

export const GENERATE_CONTENT_URL = `${SOCKET_URL}/llm/generate`;

export const GENERATE_CONTENT_NEW_FORMAT_URL_INSTITUTION = `${SOCKET_URL}/teacher/llm/generate/mutiple`;

export const SUPER_ADMIN_LOGIN = `${BASE_URL}/api/admin/Superadmin/login`;
export const SUPER_ADMIN_LOGOUT = `${BASE_URL}/api/admin/Superadmin/logout`;
export const GET_ALL_INSTITUTION_URL = `${BASE_URL}/api/admin/institution/get/all`;
export const GET_SINGLE_INSTITUTION_URL = `${BASE_URL}/api/admin/institution/get`;
export const CREATE_INSTITUTION_URL = `${BASE_URL}/api/admin/institution/create`;
export const UPDATE_INSTITUTION_URL = `${BASE_URL}/api/admin/institution/update`;
export const DELETE_INSTITUTION_URL = `${BASE_URL}/api/admin/institution/delete`;
export const GET_ALL_INSTITUTION_TEACHER_URL = `${BASE_URL}/api/admin/InstitutionUsers/get/all`;
export const CREATE_INSTITUTION_TEACHER_URL = `${BASE_URL}/api/admin/InstitutionUsers/create`;
export const UPDATE_INSTITUTION_TEACHER_URL = `${BASE_URL}/api/admin/InstitutionUsers/update`;
export const DELETE_INSTITUTION_TEACHER_URL = `${BASE_URL}/api/admin/InstitutionUsers/delete`;
export const RESET_INSTITUTION_TEACHER_PASSWORD_URL = `${BASE_URL}/api/admin/InstitutionUsers/reset-password`;
export const GET_ALL_INSTITUTION_STUDENT_URL = `${BASE_URL}/api/admin/student/users/get/all`;
export const CREATE_INSTITUTION_STUDENT_URL = `${BASE_URL}/api/admin/student/users/create`;
export const UPDATE_INSTITUTION_STUDENT_URL = `${BASE_URL}/api/admin/student/users/update`;
export const DELETE_INSTITUTION_STUDENT_URL = `${BASE_URL}/api/admin/student/users/delete`;
export const RESET_INSTITUTION_STUDENT_PASSWORD_URL = `${BASE_URL}/api/admin/student/users/reset-password`;
export const GET_ALL_INSTITUTION_COURSE_URL = `${BASE_URL}/api/admin/institutionCourses/get/all`;
export const GET_ALL_TEACHER_COURSE_URL = `${BASE_URL}/api/institution/institutionCourses/get/all`;
export const GET_ALL_INSTITUTION_COURSE_BATCH_URL = `${BASE_URL}/api/admin/batches/get/all`;
export const CREATE_INSTITUTION_COURSE_BATCH_URL = `${BASE_URL}/api/admin/batches/create`;
export const UPDATE_INSTITUTION_COURSE_BATCH_URL = `${BASE_URL}/api/admin/batches/update`;
export const DELETE_INSTITUTION_COURSE_BATCH_URL = `${BASE_URL}/api/admin/batches/delete`;
export const GET_ALL_NOT_IN_INSTITUTION_COURSE_LIST_URL = `${BASE_URL}/api/admin/course-not-in-institution/get/all`;
export const UPDATE_INSTITUTION_COURSE_URL = `${BASE_URL}/api/admin/institutionCourses/update`;
export const CREATE_INSTITUTION_COURSE_URL = `${BASE_URL}/api/admin/institutionCourses/create`;
export const GET_ONE_INSTITUTION_BATCH_TEACHER = `${BASE_URL}/api/admin/batches/get`;
export const GET_ALL_INSTITUTION_BATCH_STUDENT = `${BASE_URL}/api/admin/batches/get/students/batches`;
export const ASSIGN_INSTITUTION_BATCH_STUDENT = `${BASE_URL}/api/admin/batches/assign/students`;
export const GET_WITHOUT_ASSIGN_STUDENT_URL = `${BASE_URL}/api/admin/student/users/get/without-batch`;
export const GET_WITHOUT_ASSIGN_TEACHER_URL = `${BASE_URL}/api/admin/batches/get/teachers/not-assigned`;

export const CREATE_INITIAL_TEST_URL = `${BASE_URL}/api/admin/initial-onboarding-test/create`;
export const GET_INITIAL_TESTS_URL = `${BASE_URL}/api/admin/initial-onboarding-test/get/all`;
export const GET_INITIAL_TEST_BY_ID_URL = `${BASE_URL}/api/admin/initial-onboarding-test/get`;
export const UPDATE_INITIAL_TEST_URL = `${BASE_URL}/api/admin/initial-onboarding-test/update`;

export const GET_INSTITUTION_BATCH_TEACHER = `${BASE_URL}/api/admin/batches/get/teachers`;

export const COURSE_FOLDER_CREATE_URL = `${BASE_URL}/api/admin/question-bank-folders/course/create`;
export const SUBJECT_FOLDER_CREATE_URL = `${BASE_URL}/api/admin/question-bank-folders/subject/create`;
export const TOPIC_FOLDER_CREATE_URL = `${BASE_URL}/api/admin/question-bank-folders/topic/create`;
export const SUBTOPIC_FOLDER_CREATE_URL = `${BASE_URL}/api/admin/question-bank-folders/subtopic/create`;

export const GET_FOLDER_URL = `${BASE_URL}/api/admin/question-bank-folders/get`;
export const UPDATE_FOLDER_URL = `${BASE_URL}/api/admin/question-bank-folders/update`;
export const DELETE_FOLDER_URL = `${BASE_URL}/api/admin/question-bank-folders/delete`;

export const GET_QUESTION_BANKS_URL = `${BASE_URL}/api/admin/question-banks/get/all`;
export const GET_ONE_QUETION_BANK_URL = `${BASE_URL}/api/admin/question-banks/get`;
export const UPDATE_QUESTION_BANK_URL = `${BASE_URL}/api/admin/question-banks/update`;
export const DELETE_QUESTION_BANK_URL = `${BASE_URL}/api/admin/question-banks/delete`;
export const CREATE_QUESTION_BANK_URL = `${BASE_URL}/api/admin/question-banks/create`;

export const INSTITUTION_LOGIN_URL = `${BASE_URL}/api/institution/login`;
export const INSTITUTION_LOGOUT_URL = `${BASE_URL}/api/institution/logout`;
export const INSTITUTION_FORGOT_PASSWORD_URL = `${BASE_URL}/api/institution/forgot-password`;
export const INSTITUTION_RESET_TOKEN_VERIFICATION_URL = `${BASE_URL}/api/institution/reset-token-verification`;
export const INSTITUTION_RESET_PASSWORD_URL = `${BASE_URL}/api/institution/reset-password`;

export const INSTITUTION_TEACHER_BULK_UPLOAD = `${BASE_URL}/api/admin/InstitutionUsers/upload`;
export const INSTITUTION_STUDENT_BULK_UPLOAD = `${BASE_URL}/api/admin/student/users/upload`;
export const GET_ALL_TEACHER_INSTITUTION_URL = `${BASE_URL}/api/institution/InstitutionUsers/get/all`;
export const CREATE_TEACHER_INSTITUTION_URL = `${BASE_URL}/api/institution/InstitutionUsers/create`;
export const UPDATE_TEACHER_INSTITUTION_URL = `${BASE_URL}/api/institution/InstitutionUsers/update`;
export const DELETE_TEACHER_INSTITUTION_URL = `${BASE_URL}/api/institution/InstitutionUsers/delete`;
export const RESET_TEACHER_INSTITUTION_PASSWORD_URL = `${BASE_URL}/api/institution/InstitutionUsers/reset-password`;
export const GET_ALL_BATCH_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/get/all`;
export const GET_ONE_BATCH_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/get`;
export const GET_ONE_BATCH_ADMIN_URL = `${BASE_URL}/api/admin/batches/get`;

export const CREATE_BATCHES_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/create`;
export const UPDATE_BATCH_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/update`;
export const DELETE_BATCH_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/delete`;
export const GET_ALL_BATCH_TEACHER_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/get/teachers`;
export const GET_ALL_STUDENT_INSTITUTION_URL = `${BASE_URL}/api/institution/student/users/get/all`;
export const CREATE_STUDENT_INSTITUTION_URL = `${BASE_URL}/api/institution/student/users/create`;
export const UPDATE_STUDENT_INSTITUTION_URL = `${BASE_URL}/api/institution/student/users/update`;
export const DELETE_STUDENT_INSTITUTION_URL = `${BASE_URL}/api/institution/student/users/delete`;
export const RESET_STUDENT_INSTITUTION_PASSWORD_URL = `${BASE_URL}/api/institution/student/users/reset-password`;
export const GET_BATCH_STUDENT_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/get/students/batches`;
export const NOT_ASSIGN_TEACHER_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/get/teachers/not-assigned`;
export const NOT_ASSIGN_STUDENT_BATCH_INSTITUTION_URL = `${BASE_URL}/api/institution/student/users/get/without-batch`;
export const UPDATE_ASSIGN_BATCH_STUDENT_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/assign/students`;
export const ASSIGN_TEACHER_SUBJECTS_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/assign/teacher/subjects`;
export const GET_TEACHER_SUBJECT_ASSIGNMENT_INSTITUTION_URL = `${BASE_URL}/api/institution/batches/assign/teacher/subjects`;
export const ASSIGN_TEACHER_SUBJECTS_ADMIN_URL = `${BASE_URL}/api/admin/batches/assign/teacher/subjects`;
export const GET_TEACHER_SUBJECT_ASSIGNMENT_ADMIN_URL = `${BASE_URL}/api/admin/batches/assign/teacher/subjects`;

export const CREATE_MATERIAL_COURSE_FOLDER_URL = `${BASE_URL}/api/admin/materials-folders/course/create`;
export const CREATE_MATERIAL_SUBJECT_FOLDER_URL = `${BASE_URL}/api/admin/materials-folders/subject/create`;
export const CREATE_MATERIAL_TOPIC_FOLDER_URL = `${BASE_URL}/api/admin/materials-folders/topic/create`;
export const CREATE_MATERIAL_SUBTOPIC_FOLDER_URL = `${BASE_URL}/api/admin/materials-folders/subtopic/create`;
export const GET_MATERIAL_FOLDER_URL = `${BASE_URL}/api/admin/materials-folders/get`;
export const UPDATE_MATERIAL_FOLDER_URL = `${BASE_URL}/api/admin/materials-folders/update`;
export const DELETE_MATERIAL_FOLDER_URL = `${BASE_URL}/api/admin/materials-folders/delete`;
export const CREATE_MATERIAL_URL = `${BASE_URL}/api/admin/materials/create`;
export const GET_MATERIALS_URL = `${BASE_URL}/api/admin/materials/get/all`;
export const GET_MATERIAL_URL = `${BASE_URL}/api/admin/materials/get`;
export const GET_MATERIALS_BY_TITLE_KEY_URL = `${BASE_URL}/api/admin/materials/get/by-title-key`;
export const UPDATE_MATERIAL_URL = `${BASE_URL}/api/admin/materials/update`;
export const DELETE_MATERIAL_URL = `${BASE_URL}/api/admin/materials/delete`;
export const GET_PREFERENCE_URL = `${BASE_URL}/api/admin/preference-questions/get/all`;
export const CREATE_PREFERENCE_URL = `${BASE_URL}/api/admin/preference-questions/create`;
export const GET_ONE_PREFERENCE_URL = `${BASE_URL}/api/admin/preference-questions/get`;
export const UPDATE_PREFERENCE_URL = `${BASE_URL}/api/admin/preference-questions/update`;
export const GET_BREADCRUMB_URL = `${BASE_URL}/api/admin/get_breadcrumps`;
export const GET_BREADCRUMB_URL_TEACHER = `${BASE_URL}/api/teacher/get_breadcrumps`;
export const DELETE_PREFERENCE_URL = `${BASE_URL}/api/admin/preference-questions/delete`;
export const GET_IQ_TEST_URL = `${BASE_URL}/api/admin/initial-onboarding-test/get/all`;
export const GENERATE_AI_IQ_TEST_QUESTION = `${SOCKET_URL}/llm/generate/iqpsychometric`;
export const CREATE_MANUAL_IQ_TEST_QUESTION = `${BASE_URL}/api/admin/initial-onboarding-test/create`;
export const GET_ONE_IQ_TEST_QUESTION = `${BASE_URL}/api/admin/initial-onboarding-test/get`;
export const UPDATE_IQ_TEST_QUESTION = `${BASE_URL}/api/admin/initial-onboarding-test/update`;
export const DELETE_IQ_TEST_QUESTION = `${BASE_URL}/api/admin/initial-onboarding-test/delete`;

export const ADMIN_MODEL_CREATE_URL = `${BASE_URL}/api/admin/model/create`;
export const ADMIN_MODEL_UPDATE_URL = `${BASE_URL}/api/admin/model/update`;
export const ADMIN_MODEL_DELETE_URL = `${BASE_URL}/api/admin/model/delete`;
export const ADMIN_MODELS_GET_URL = `${BASE_URL}/api/admin/model/get/all`;
export const ADMIN_MODEL_GET_URL = `${BASE_URL}/api/admin/model/get`;

export const GET_PROMPTS_URL = `${BASE_URL}/api/admin/prompt/get/all`;
export const GET_PROMPT_URL = `${BASE_URL}/api/admin/prompt/get`;
export const UPDATE_PROMPT_URL = `${BASE_URL}/api/admin/prompt/update`;
export const CREATE_PROMPT_URL = `${BASE_URL}/api/admin/prompt/create`;
export const DELETE_PROMPT_URL = `${BASE_URL}/api/admin/prompt/delete`;

export const CREATE_EVAL_PROMPT_URL = `${BASE_URL}/api/admin/eval_prompt/create`;
export const GET_EVAL_PROMPTS_URL = `${BASE_URL}/api/admin/eval_prompt/get/all`;
export const GET_EVAL_PROMPT_URL = `${BASE_URL}/api/admin/eval_prompt/get`;
export const UPDATE_EVAL_PROMPT_URL = `${BASE_URL}/api/admin/eval_prompt/update`;
export const DELETE_EVAL_PROMPT_URL = `${BASE_URL}/api/admin/eval_prompt/delete`;

export const CREATE_PERSONA_URL = `${BASE_URL}/api/admin/persona/create`;
export const UPDATE_PERSONA_URL = `${BASE_URL}/api/admin/persona/update`;
export const GET_PERSONAS_URL = `${BASE_URL}/api/admin/persona/get/all`;
export const GET_PERSONA_URL = `${BASE_URL}/api/admin/persona/get`;
export const DELETE_PERSONA_URL = `${BASE_URL}/api/admin/persona/delete`;

export const CREATE_PAGE_FOR_COURSE_URL_INSTITUTION = `${BASE_URL}/api/institution/course-page-content/create`;
export const UPDATE_PAGE_FOR_COURSE_URL_INSTITUTION = `${BASE_URL}/api/institution/course-page-content/update`;
export const DELETE_PAGE_FOR_COURSE_URL_INSTITUTION = `${BASE_URL}/api/institution/course-page-content/delete`;
export const GET_PAGE_FOR_COURSE_URL_INSTITUTION = `${BASE_URL}/api/institution/course-page-content/get/all`;
export const GET_SINGLE_PAGE_FOR_COURSE_URL_INSTITUTION = `${BASE_URL}/api/institution/course-page-content/get_one`;

export const CREATE_PAGE_FOR_SUBJECT_URL_INSTITUTION = `${BASE_URL}/api/institution/subject-page-content/create`;
export const UPDATE_PAGE_FOR_SUBJECT_URL_INSTITUTION = `${BASE_URL}/api/institution/subject-page-content/update`;
export const DELETE_PAGE_FOR_SUBJECT_URL_INSTITUTION = `${BASE_URL}/api/institution/subject-page-content/delete`;
export const GET_PAGE_FOR_SUBJECT_URL_INSTITUTION = `${BASE_URL}/api/institution/subject-page-content/get/all`;
export const GET_SINGLE_PAGE_FOR_SUBJECT_URL_INSTITUTION = `${BASE_URL}/api/institution/subject-page-content/get`;

export const CREATE_PAGE_FOR_TOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/topic-page-content/create`;
export const UPDATE_PAGE_FOR_TOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/topic-page-content/update`;
export const DELETE_PAGE_FOR_TOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/topic-page-content/delete`;
export const GET_PAGES_FOR_TOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/topic-page-content/get/all`;
export const GET_SINGLE_PAGE_FOR_TOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/topic-page-content/get`;

export const CREATE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/subtopic-page-content/create`;
export const UPDATE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/subtopic-page-content/update`;
export const DELETE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/subtopic-page-content/delete`;
export const GET_PAGE_FOR_SUBTOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/subtopic-page-content/get/all`;
export const GET_SINGLE_PAGE_FOR_SUBTOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/subtopic-page-content/get`;

export const GET_COURSES_URL_INSTITUTION = `${BASE_URL}/api/institution/institutionCourses/get/all`;
export const GET_SINGLE_COURSE_URL_INSTITUTION = `${BASE_URL}/api/institution/institutionCourses/get`;

export const GET_SUBJECTS_URL_INSTITUTION = `${BASE_URL}/api/institution/subject/get/all`;

export const GET_TOPICS_URL_INSTITUTION = `${BASE_URL}/api/institution/info/topic/get/all`;

export const GET_SUBTOPIC_URL_INSTITUTION = `${BASE_URL}/api/institution/info/subtopic/get/all`;

export const GET_ADMIN_COURSE_PAGE_CONTENT_FOR_INSTITUTION = `${BASE_URL}/api/institution/info/course-page-content/get/all`;
export const GET_ADMIN_SUBJECT_PAGE_CONTENT_FOR_INSTITUTION = `${BASE_URL}/api/institution/info/subject-page-content/get/all`;
export const GET_ADMIN_TOPIC_PAGE_CONTENT_FOR_INSTITUTION = `${BASE_URL}/api/institution/info/topic-page-content/get/all`;
export const GET_ADMIN_SUBTOPIC_PAGE_CONTENT_FOR_INSTITUTION = `${BASE_URL}/api/institution/info/subtopic-page-content/get/all`;

export const GET_ADMIN_SINGLE_COURSE_PAGE_CONTENT_FOR_INSTITUTION = `${BASE_URL}/api/institution/info/course-page-content/get`;
export const GET_ADMIN_SINGLE_SUBJECT_PAGE_CONTENT_FOR_INSTITUTION = `${BASE_URL}/api/institution/info/subject-page-content/get`;
export const GET_ADMIN_SINGLE_TOPIC_PAGE_CONTENT_FOR_INSTITUTION = `${BASE_URL}/api/institution/info/topic-page-content/get`;
export const GET_ADMIN_SINGLE_SUBTOPIC_PAGE_CONTENT_FOR_INSTITUTION = `${BASE_URL}/api/institution/info/subtopic-page-content/get`;

export const GENERATE_CONTENT_NEW_FORMAT_URL = `${SOCKET_URL}/llm/generate/mutiple`;
export const GENERATE_CONTENT_TEACHER_URL = `${SOCKET_URL}/teacher/llm/generate/mutiple`;

export const GET_ADMIN_QUESTION_BANKS_IN_INSTITUTION = `${BASE_URL}/api/institution/info/question-banks/get/all`;
export const GET_ADMIN_SINGLE_QUESTION_BANK_IN_INSTITUTION = `${BASE_URL}/api/institution/info/question-banks/get`;
export const GET_ADMIN_QUESTION_BANKS_FOLDERS_IN_INSTITUTION = `${BASE_URL}/api/institution/question-bank-folders/get`;

export const CREATE_QUESTION_BANK_FOLDER_INSTITUTION = `${BASE_URL}/api/institution/question-banks/folder/course/create`;
export const UPDATE_QUESTION_BANK_FOLDER_INSTITUTION = `${BASE_URL}/api/institution/question-banks/folder/update`;
export const DELETE_QUESTION_BANK_FOLDER_INSTITUTION = `${BASE_URL}/api/institution/question-banks/folder/delete`;
export const GET_ALL_QUESTION_BANK_FOLDERS_INSTITUITION = `${BASE_URL}/api/institution/question-banks/folder/get/all`;

export const CREATE_QUESTION_BANK_INSTITUTION = `${BASE_URL}/api/institution/question-banks/create`;
export const UPDATE_QUESTION_BANK_INSTITUTION = `${BASE_URL}/api/institution/question-banks/update`;
export const DELETE_QUESTION_BANK_INSTITUTION = `${BASE_URL}/api/institution/question-banks/delete`;
export const GET_QUESTION_BANKS_INSTITUTION = `${BASE_URL}/api/institution/question-banks/get/all`;
export const GET_QUESTION_BANK_INSTITUTION = `${BASE_URL}/api/institution/question-banks/get`;

export const GET_ADMIN_MATERIALS_FOLDER_IN_INSTITUTION = `${BASE_URL}/api/institution/materials-folders/get`;
export const CREATE_MATERIAL_FOLDER_INSTITUTION_URL = `${BASE_URL}/api/institution/info/materials-folders/create`;
export const UPDATE_MATERIAL_FOLDER_INSTITUTION_URL = `${BASE_URL}/api/institution/info/materials-folders/update`;
export const DELETE_MATERIAL_FOLDER_INSTITUTION_URL = `${BASE_URL}/api/institution/info/materials-folders/delete`;
export const GET_MATERIAL_FOLDERS_INSTITUTION_URL = `${BASE_URL}/api/institution/info/materials-folders/get/all`;

export const GET_ADMIN_MATERIALS_IN_INSTITUTION = `${BASE_URL}/api/institution/materials/get/all`;
export const GET_ADMIN_MATERIAL_IN_INSTITUTION = `${BASE_URL}/api/institution/materials/get`;

export const CREATE_MATERIAL_IN_INSTITUTION = `${BASE_URL}/api/institution/info/materials/create`;
export const UPDATE_MATERIAL_IN_INSTITUTION = `${BASE_URL}/api/institution/info/materials/update`;
export const DELETE_MATERIAL_IN_INSTITUTION = `${BASE_URL}/api/institution/info/materials/delete`;
export const GET_MATERIALS_IN_INSTITUTION = `${BASE_URL}/api/institution/info/materials/get/all`;
export const GET_MATERIAL_IN_INSTITUTION = `${BASE_URL}/api/institution/info/materials/get`;

export const CREATE_COINS_URL = `${BASE_URL}/api/admin/coins/create`;
export const UPDATE_COINS_URL = `${BASE_URL}/api/admin/coins/update`;
export const DELETE_COINS_URL = `${BASE_URL}/api/admin/coins/delete`;
export const GET_COINS_URL = `${BASE_URL}/api/admin/coins/get/all`;

export const CREATE_XP_URL = `${BASE_URL}/api/admin/xp/create`;
export const UPDATE_XP_URL = `${BASE_URL}/api/admin/xp/update`;
export const DELETE_XP_URL = `${BASE_URL}/api/admin/xp/delete`;
export const GET_XP_URL = `${BASE_URL}/api/admin/xp/get/all`;

export const GET_INSTITUTION_PROFILE_URL = `${BASE_URL}/api/institution/InstitutionUsers/profile`;

export const GET_ADMIN_PROFILE_URL = `${BASE_URL}/api/admin/Superadmin/profile`;

export const UPDATE_ADMIN_PROFILE_URL = `${BASE_URL}/api/admin/InstitutionUsers/profile/update`;

export const UPDATE_INSTITUTION_PROFILE_URL = `${BASE_URL}/api/institution/InstitutionUsers/profile/update`;

export const CHANGE_ADMIN_PASSWORD_URL = `${BASE_URL}/api/admin/Superadmin/profile/change-password`;
export const CHANGE_INSTITUTION_PASSWORD_URL = `${BASE_URL}/api/institution/InstitutionUsers/profile/change-password`;

export const CREATE_HOME_WORK_COURSE_URL = `${BASE_URL}/api/teacher/course/homework/create`;
export const UPDATE_HOME_WORK_COURSE_URL = `${BASE_URL}/api/teacher/course/homework/update`;
export const GET_HOME_WORKS_COURSE_URL = `${BASE_URL}/api/teacher/course/homework/get/all`;
export const GET_HOME_WORK_COURSE_URL = `${BASE_URL}/api/teacher/course/homework/get`;
export const DELETE_HOME_WORK_COURSE_URL = `${BASE_URL}/api/teacher/course/homework/delete`;

export const CREATE_HOME_WORK_SUBJECT_URL = `${BASE_URL}/api/teacher/subject/homework/create`;
export const UPDATE_HOME_WORK_SUBJECT_URL = `${BASE_URL}/api/teacher/subject/homework/update`;
export const GET_HOME_WORKS_SUBJECT_URL = `${BASE_URL}/api/teacher/subject/homework/get/all`;
export const GET_HOME_WORK_SUBJECT_URL = `${BASE_URL}/api/teacher/subject/homework/get`;
export const DELETE_HOME_WORK_SUBJECT_URL = `${BASE_URL}/api/teacher/subject/homework/delete`;

export const CREATE_HOME_WORK_TOPIC_URL = `${BASE_URL}/api/teacher/topic/homework/create`;
export const UPDATE_HOME_WORK_TOPIC_URL = `${BASE_URL}/api/teacher/topic/homework/update`;
export const GET_HOME_WORKS_TOPIC_URL = `${BASE_URL}/api/teacher/topic/homework/get/all`;
export const GET_HOME_WORK_TOPIC_URL = `${BASE_URL}/api/teacher/topic/homework/get`;
export const DELETE_HOME_WORK_TOPIC_URL = `${BASE_URL}/api/teacher/topic/homework/delete`;

export const CREATE_HOME_WORK_SUB_TOPIC_URL = `${BASE_URL}/api/teacher/subtopic/homework/create`;
export const UPDATE_HOME_WORK_SUB_TOPIC_URL = `${BASE_URL}/api/teacher/subtopic/homework/update`;
export const GET_HOME_WORKS_SUB_TOPIC_URL = `${BASE_URL}/api/teacher/subtopic/homework/get/all`;
export const GET_HOME_WORK_SUB_TOPIC_URL = `${BASE_URL}/api/teacher/subtopic/homework/get`;
export const DELETE_HOME_WORK_SUB_TOPIC_URL = `${BASE_URL}/api/teacher/subtopic/homework/delete`;

export const GET_HOME_WORK_ASSIGNED_STUDENTS_URL = `${BASE_URL}/api/teacher/student/users/get/all/assign`;

export const GET_HOME_WORK_COMPLETED_STUDENTS_URL = `${BASE_URL}/api/teacher/homework/completed/get/all`;

export const GET_HOME_WORK_COMPLETED_STUDENT_URL = `${BASE_URL}/api/teacher/homework/completed/get`;

export const OVERALL_TEST_CREATE_URL = `${BASE_URL}/api/institution/overall-course-test/create`;
export const OVERALL_TEST_UPDATE_URL = `${BASE_URL}/api/institution/overall-course-test/update`;
export const OVERALL_TEST_DELETE_URL = `${BASE_URL}/api/institution/overall-course-test/delete`;
export const OVERALL_TEST_GET_URL = `${BASE_URL}/api/institution/overall-course-test/get/all`;
export const OVERALL_TEST_GET_SINGLE_URL = `${BASE_URL}/api/institution/overall-course-test/get`;
export const GENERATE_AUDIO_BOOK = `${SOCKET_URL}/generate/speech`;

export const GET_OVERALL_TEST_SUBMITTED_STUDENTS = `${BASE_URL}/api/institution/overall-course-test/submission/get/all`;
export const GET_OVERALL_TEST_SUBMITTED_STUDENT = `${BASE_URL}/api/institution/overall-course-test/submission/get`;

export const TEACHER_OVERALL_TEST_CREATE_URL = `${BASE_URL}/api/teacher/overall-course-test/create`;
export const TEACHER_OVERALL_TEST_UPDATE_URL = `${BASE_URL}/api/teacher/overall-course-test/update`;
export const TEACHER_OVERALL_TEST_DELETE_URL = `${BASE_URL}/api/teacher/overall-course-test/delete`;
export const TEACHER_OVERALL_TEST_GET_URL = `${BASE_URL}/api/teacher/overall-course-test/get/all`;
export const TEACHER_OVERALL_TEST_GET_SINGLE_URL = `${BASE_URL}/api/teacher/overall-course-test/get`;

export const TEACHER_GET_OVERALL_TEST_SUBMITTED_STUDENTS = `${BASE_URL}/api/teacher/overall-course-test/submission/get/all`;
export const TEACHER_GET_OVERALL_TEST_SUBMITTED_STUDENT = `${BASE_URL}/api/teacher/overall-course-test/submission/get`;

export const ADMIN_OVERALL_TEST_CREATE_URL = `${BASE_URL}/api/admin/overall-course-test/create`;
export const ADMIN_OVERALL_TEST_UPDATE_URL = `${BASE_URL}/api/admin/overall-course-test/update`;
export const ADMIN_OVERALL_TEST_DELETE_URL = `${BASE_URL}/api/admin/overall-course-test/delete`;
export const ADMIN_OVERALL_TEST_GET_URL = `${BASE_URL}/api/admin/overall-course-test/get/all`;
export const ADMIN_OVERALL_TEST_GET_SINGLE_URL = `${BASE_URL}/api/admin/overall-course-test/get`;

export const ADMIN_GET_OVERALL_TEST_SUBMITTED_STUDENTS = `${BASE_URL}/api/admin/overall-course-test/submission/get/all`;
export const ADMIN_GET_OVERALL_TEST_SUBMITTED_STUDENT = `${BASE_URL}/api/admin/overall-course-test/submission/get`;

export const CREATE_OVERALL_MATERIAL_URL = `${BASE_URL}/api/institution/overall-materials/create`;
export const UPDATE_OVERALL_MATERIAL_URL = `${BASE_URL}/api/institution/overall-materials/update`;
export const DELETE_OVERALL_MATERIAL_URL = `${BASE_URL}/api/institution/overall-materials/delete`;
export const GET_OVERALL_MATERIALS_URL = `${BASE_URL}/api/institution/overall-materials/get/all`;
export const GET_OVERALL_MATERIAL_URL = `${BASE_URL}/api/institution/overall-materials/get`;

export const CREATE_OVERALL_MATERIAL_URL_TEACHER = `${BASE_URL}/api/teacher/overall-materials/create`;
export const UPDATE_OVERALL_MATERIAL_URL_TEACHER = `${BASE_URL}/api/teacher/overall-materials/update`;
export const DELETE_OVERALL_MATERIAL_URL_TEACHER = `${BASE_URL}/api/teacher/overall-materials/delete`;
export const GET_OVERALL_MATERIALS_URL_TEACHER = `${BASE_URL}/api/teacher/overall-materials/get/all`;
export const GET_OVERALL_MATERIAL_URL_TEACHER = `${BASE_URL}/api/teacher/overall-materials/get`;

export const ADMIN_CREATE_OVERALL_MATERIAL_URL = `${BASE_URL}/api/admin/overall-materials/create`;
export const ADMIN_UPDATE_OVERALL_MATERIAL_URL = `${BASE_URL}/api/admin/overall-materials/update`;
export const ADMIN_DELETE_OVERALL_MATERIAL_URL = `${BASE_URL}/api/admin/overall-materials/delete`;
export const ADMIN_GET_OVERALL_MATERIALS_URL = `${BASE_URL}/api/admin/overall-materials/get/all`;
export const ADMIN_GET_OVERALL_MATERIAL_URL = `${BASE_URL}/api/admin/overall-materials/get`;

export const CREATE_BLOG_INSTITUTION_URL = `${BASE_URL}/api/institution/course-blog/create`;
export const UPDATE_BLOG_INSTITUTION_URL = `${BASE_URL}/api/institution/course-blog/update`;
export const DELETE_BLOG_INSTITUTION_URL = `${BASE_URL}/api/institution/course-blog/delete`;
export const GET_BLOG_INSTITUTION_URL = `${BASE_URL}/api/institution/course-blog/get/all`;
export const GET_BLOG_INSTITUTION_SINGLE_URL = `${BASE_URL}/api/institution/course-blog/get`;

export const CREATE_BLOG_ADMIN_URL = `${BASE_URL}/api/admin/course-blog/create`;
export const UPDATE_BLOG_ADMIN_URL = `${BASE_URL}/api/admin/course-blog/update`;
export const DELETE_BLOG_ADMIN_URL = `${BASE_URL}/api/admin/course-blog/delete`;
export const GET_BLOG_ADMIN_URL = `${BASE_URL}/api/admin/course-blog/get/all`;
export const GET_BLOG_ADMIN_SINGLE_URL = `${BASE_URL}/api/admin/course-blog/get`;

export const CREATE_BLOG_TEACHER_URL = `${BASE_URL}/api/teacher/course-blog/create`;
export const UPDATE_BLOG_TEACHER_URL = `${BASE_URL}/api/teacher/course-blog/update`;
export const DELETE_BLOG_TEACHER_URL = `${BASE_URL}/api/teacher/course-blog/delete`;
export const GET_BLOG_TEACHER_URL = `${BASE_URL}/api/teacher/course-blog/get/all`;
export const GET_BLOG_TEACHER_SINGLE_URL = `${BASE_URL}/api/teacher/course-blog/get`;

export const GET_ALL_VIDEOS = `${BASE_URL}/api/teacher/videos/get/all`;
export const UPLOAD_VIDEO_URL = `${BASE_URL}/api/teacher/videos/upload`;
export const UPDATE_VIDEO_URL = `${BASE_URL}/api/teacher/videos/update`;
export const DELETE_VIDEO_URL = `${BASE_URL}/api/teacher/videos/delete`;

export const PDF_TO_MARKDOWN_CONVERT_URL = `${SOCKET_URL}/pdf/convert`;

export const GET_ADMIN_DASHBOARD_1 = `${BASE_URL}/api/admin/dashboard/get`;

export const GET_ADMIN_DASHBOARD_2 = `${BASE_URL}/api/admin/dashboard/get/institution`;

export const GET_ADMIN_DASHBOARD_3 = `${BASE_URL}/api/admin/dashboard/get/institution/course/overview`;

export const GET_ADMIN_DASHBOARD_4 = `${BASE_URL}/api/admin/dashboard/get/batches`;

export const GET_ADMIN_DASHBOARD_5 = `${BASE_URL}/api/admin/dashboard/get/all/teachers`;

export const GET_ADMIN_DASHBOARD_6 = `${BASE_URL}/api/admin/dashboard/get/teachers`;

export const GET_ADMIN_DASHBOARD_7 = `${BASE_URL}/api/admin/dashboard/get/all/users`;

export const GET_ADMIN_DASHBOARD_8 = `${BASE_URL}/api/admin/dashboard/get/one/user/overview`;

export const GET_ADMIN_DASHBOARD_9 = `${BASE_URL}/api/admin/dashboard/get/one/user/analytics`;

export const GET_INSTITUTION_DASHBOARD_1 = `${BASE_URL}/api/institution/dashboard/get`;

export const GET_INSTITUTION_DASHBOARD_2 = `${BASE_URL}/api/institution/dashboard/get/course/overview`;

export const GET_INSTITUTION_DASHBOARD_3 = `${BASE_URL}/api/institution/dashboard/get/batches`;

export const GET_INSTITUTION_DASHBOARD_4 = `${BASE_URL}/api/institution/dashboard/get/all/teachers`;

export const GET_INSTITUTION_DASHBOARD_5 = `${BASE_URL}/api/institution/dashboard/get/teachers`;

export const GET_INSTITUTION_DASHBOARD_6 = `${BASE_URL}/api/institution/dashboard/get/all/users`;

export const GET_INSTITUTION_DASHBOARD_7 = `${BASE_URL}/api/institution/dashboard/get/one/user/overview`;

export const GET_INSTITUTION_DASHBOARD_8 = `${BASE_URL}/api/institution/dashboard/get/one/user/analytics`;

export const GET_COURSE_PAGE_EVAL_STATUS_URL = `${BASE_URL}/api/admin/eval-course-page-content/eval/status`;

export const GET_SUBJECT_PAGE_EVAL_STATUS_URL = `${BASE_URL}/api/admin/eval-subject-page-content/eval/status`;

export const GET_TOPIC_PAGE_EVAL_STATUS_URL = `${BASE_URL}/api/admin/eval-topic-page-content/eval/status`;

export const GET_SUBTOPIC_PAGE_EVAL_STATUS_URL = `${BASE_URL}/api/admin/eval-subtopic-page-content/eval/status`;

export const CREATE_COURSE_EVAL_PAGE_CONTENT_URL = `${BASE_URL}/api/admin/eval-course-page-content/create`;

export const CREATE_SUBJECT_EVAL_PAGE_CONTENT_URL = `${BASE_URL}/api/admin/eval-subject-page-content/create`;

export const CREATE_TOPIC_EVAL_PAGE_CONTENT_URL = `${BASE_URL}/api/admin/eval-topic-page-content/create`;

export const CREATE_SUBTOPIC_EVAL_PAGE_CONTENT_URL = `${BASE_URL}/api/admin/eval-subtopic-page-content/create`;

export const GET_COURSE_EVAL_PAGE_CONTENT_URL = `${BASE_URL}/api/admin/eval-course-page-content/get`;

export const GET_SUBJECT_EVAL_PAGE_CONTENT_URL = `${BASE_URL}/api/admin/eval-subject-page-content/get`;

export const GET_TOPIC_EVAL_PAGE_CONTENT_URL = `${BASE_URL}/api/admin/eval-topic-page-content/get`;

export const GET_SUBTOPIC_EVAL_PAGE_CONTENT_URL = `${BASE_URL}/api/admin/eval-subtopic-page-content/get`;

export const EVAL_WITH_AI_URL = `${BASE_URL}/api/admin/eval-llm-generation/mark`;

export const GET_ADMIN_CUMULATIVE_DASHBOARD_URL = `${BASE_URL}/api/admin/dashboard/get/superadmin/overview`;

export const GET_INSTITUTION_CUMULATIVE_DASHBOARD_URL_1 = `${BASE_URL}/api/institution/dashboard/overview`;
export const GET_INSTITUTION_CUMULATIVE_DASHBOARD_URL_2 = `${BASE_URL}/api/institution/dashboard/course/overview`;
export const GET_INSTITUTION_CUMULATIVE_DASHBOARD_URL_3 = `${BASE_URL}/api/institution/dashboard/batch/overview`;

export const GET_TEACHER_CUMULATIVE_DASHBOARD_URL_1 = `${BASE_URL}/api/teacher/dashboard/overview`;
export const GET_TEACHER_CUMULATIVE_DASHBOARD_URL_2 = `${BASE_URL}/api/teacher/dashboard/course`;
export const GET_TEACHER_CUMULATIVE_DASHBOARD_URL_3 = `${BASE_URL}/api/teacher/dashboard/batch`;

export const UPLOAD_PAGE_CONTENT_FILE_URL = `${BASE_URL}/api/admin/page-content/files/upload`;
export const REMOVE_PAGE_CONTENT_FILE_URL = `${BASE_URL}/api/admin/page-content/files/remove`;

export const UPLOAD_PAGE_CONTENT_FILE_URL_INSTITUTION = `${BASE_URL}/api/institution/page-content/files/upload`;
export const REMOVE_PAGE_CONTENT_FILE_URL_INSTITUTION = `${BASE_URL}/api/institution/page-content/files/remove`;

export const GET_IMAGE_FOLDERS_URL = `${BASE_URL}/api/admin/images/folder/all`;
export const CREATE_IMAGE_FOLDER_URL = `${BASE_URL}/api/admin/images/folder/create`;
export const UPDATE_IMAGE_FOLDER_URL = `${BASE_URL}/api/admin/images/folder/edit`;
export const DELETE_IMAGE_FOLDER_URL = `${BASE_URL}/api/admin/images/folder/delete`;
export const GET_IMAGE_FOLDER_DETAILS_URL = `${BASE_URL}/api/admin/images/folder/one`;
export const UPLOAD_IMAGE_URL = `${BASE_URL}/api/admin/images/upload`;
export const DELETE_IMAGE_URL = `${BASE_URL}/api/admin/images/delete`;
